import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { NoticeEntity } from "@youm-front/notice/domain";

@Component({
  selector: "app-notice-ui-notice-list",
  templateUrl: "./notice-list.component.html",
  styleUrls: ["./notice-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoticeListComponent {
  @Input() notices!: NoticeEntity[];

  @Output() delete = new EventEmitter<NoticeEntity>();

  onDelete(notice: NoticeEntity) {
    this.delete.emit(notice);
  }
}
